<template>
<div>
  <div class="wistia_embed wistia_async_l1ezf1zwh6">
    &nbsp;
  </div>

  <div
    id="fsa_claims_process"
    class="tbk-vid-embed"
  >
    <a
      id="health_care_fsa_process"
      class="embedded_video"
      href="#wistia_32as4lqy9s?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="dependent_care_fsa_process"
      class="embedded_video"
      href="#wistia_i0nxljn9vo?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="limited_purpose_fsa_process"
      class="embedded_video"
      href="#wistia_swsctl3lle?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="replay_intro"
      class="embedded_video"
      href="#wistia_l1ezf1zwh6?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('l1e', 21, this.showSelect)
    this.tbk.loadCrossTime('32a', 116, this.showSelect)
    this.tbk.loadCrossTime('i0n', 115, this.showSelect)
    this.tbk.loadCrossTime('sws', 119, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '32a': this.tbk.autoPlay,
        i0n: this.tbk.autoPlay,
        sws: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('#fsa_claims_process').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
#fsa_claims_process
  display: none
  a
    text-decoration: none
#health_care_fsa_process
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (42 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))
#dependent_care_fsa_process
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (239 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))
#limited_purpose_fsa_process
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (438 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))
#replay_intro
  position: absolute
  top: calc(100% * (294 / 360))
  left: calc(100% * (221 / 640))
  width: calc(100% * (195 / 640))
  height: calc(100% * (30 / 360))
</style>
